module.exports = __webpack_public_path__ + "1c7c5128ceea44c82ce7d0db18c2a814.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/Space-Marine_1.jpg
// module id = 292
// module chunks = 0